<template>
    <div class="cont-result-faq margin-general">
        <NuxtLink :to="localPath('/faq')" class="back-link">
            <span data-v-b04161ba="" class="material-symbols-outlined" translate="no">chevron_left</span>
            {{ $t("faq.goback") }}
        </NuxtLink>
        <div class="sub-cont">
            <FaqAccordion>
                <div class="accordeon container movil">
                    <div class="content-main-tab">
                        <div class="tab-content">
                            <div class="contet-general">
                                <h4 role="heading" aria-level="1">{{ $t("faq.tab43.title1") }}</h4>
                                <div class="icon-text">
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span>{{ $t("faq.tab43.text1") }}</span></p>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">password</span>
                                    <div class="list-number"><span>1.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span v-html="formatContent('faq.tab43.text2', $t, localPath)"></span></p>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">settings</span>
                                    <div class="list-number"><span>2.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span>{{ $t("faq.tab43.text3") }}</span></p>
                                        <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/PrivacyAndSecurity-q2-01-movil.png"><img src="/images/faq/PrivacyAndSecurity-q2-01.png" alt="Imagen 1" class="responsive-image"></picture>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">encrypted</span>
                                    <div class="list-number"><span>3.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span>{{ $t("faq.tab43.text4") }}</span></p>
                                        <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/PrivacyAndSecurity-q2-02-movil.jpg"><img src="/images/faq/PrivacyAndSecurity-q2-02.png" alt="Imagen 1" class="responsive-image"></picture>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">app_promo</span>
                                    <div class="list-number"><span>4.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span>{{ $t("faq.tab43.text5") }}</span></p>
                                        <p class="body-4"><span>{{ $t("faq.tab43.text6") }}</span></p>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">qr_code</span>
                                    <div class="list-number"><span>5.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span>{{ $t("faq.tab43.text7") }}</span></p>
                                        <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/PrivacyAndSecurity-q2-03-movil.jpg"><img src="/images/faq/PrivacyAndSecurity-q2-03.png" alt="Imagen 1" class="responsive-image"></picture>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">verified_user</span>
                                    <div class="list-number"><span>6.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span>{{ $t("faq.tab43.text8") }}</span></p>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FaqAccordion>
            <div class="accordeon container destock">
                <div class="content-main-tab">
                    <div class="tab-content">
                        <div class="contet-general">
                            <h1>{{ $t("faq.tab43.title1") }}</h1>
                            <div class="icon-text">
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span>{{ $t("faq.tab43.text1") }}</span></p>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">password</span>
                                <div class="list-number"><span>1.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span v-html="formatContent('faq.tab43.text2', $t, localPath)"></span></p>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">settings</span>
                                <div class="list-number"><span>2.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span>{{ $t("faq.tab43.text3") }}</span></p>
                                    <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/PrivacyAndSecurity-q2-01-movil.png"><img src="/images/faq/PrivacyAndSecurity-q2-01.png" alt="Imagen 1" class="responsive-image"></picture>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">encrypted</span>
                                <div class="list-number"><span>3.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span>{{ $t("faq.tab43.text4") }}</span></p>
                                    <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/PrivacyAndSecurity-q2-02-movil.jpg"><img src="/images/faq/PrivacyAndSecurity-q2-02.png" alt="Imagen 1" class="responsive-image"></picture>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">app_promo</span>
                                <div class="list-number"><span>4.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span>{{ $t("faq.tab43.text5") }}</span></p>
                                    <p class="body-4"><span>{{ $t("faq.tab43.text6") }}</span></p>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">qr_code</span>
                                <div class="list-number"><span>5.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span>{{ $t("faq.tab43.text7") }}</span></p>
                                    <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/PrivacyAndSecurity-q2-03-movil.jpg"><img src="/images/faq/PrivacyAndSecurity-q2-03.png" alt="Imagen 1" class="responsive-image"></picture>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">verified_user</span>
                                <div class="list-number"><span>6.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span>{{ $t("faq.tab43.text8") }}</span></p>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>

<script setup>
const { t, locale } = useI18n();
const route = useRoute();
const localPath = useLocalePath();
import FaqAccordion from '~/components/faq/FaqAccordion.vue'

useFaqSeoMeta("faq.tab43.title1", "faq.tab43.text1");
</script>

